import { useContext } from 'react';
import { LoaderContext } from './LoaderContext';

export default function useBlockingLoader() {
  const loader = useContext(LoaderContext);

  if (!loader) {
    throw new Error(
      "useBlockingLoader: no LoaderProvider mounted. Mount <LoaderProvider> (from 'shared') above anything that fetches.",
    );
  }

  return loader;
}
